function interscrollerCheck() {
    //$('body').append('<span style="position: fixed; bottom: 0; right: 0;">'+$('.interscroller-banner .interscroller_box iframe[id^=adf_]').contents().height()+'</span>');

    if($('.interscroller-banner .interscroller_box').length===0) {
        //alert('hide');
        $('.interscroller-banner .wrapAd').hide();
    } else {
        //alert('nohide');
    }
}

$(document).ready(function() {
    $(".lazy_leaderboard").lazyLoadAd({
        threshold: 20000,
        timeout: 900
    });
    $(".lazy").lazyLoadAd({
        threshold: 10,
        timeout: 900
    });
    $(".lazy_l").lazyLoadAd({
        threshold: 10,
        timeout: 1000
    });
    $(".lazy_p").lazyLoadAd({
        threshold: 10,
        timeout: 1000
    });
    $(".lazy_is").lazyLoadAd({
        threshold:  500,
        timeout:    200,
        onComplete: function() {
            setTimeout(interscrollerCheck,1000);
        },
        // debug:      true
    });

    if(typeof tempNamespace['pozadiL'] != "undefined") {
        $("#main-content").addClass("bgAdLoaded");
    }
});

var checkSmallDevice = function() {
    var deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var smallDevice = false;
    if (deviceWidth < 768) {
        smallDevice = true;
    }
    return smallDevice;
};

